(function ($) {

    function inputHandler() {

        var inputs = $('.wpcf7-form input[type=text], .wpcf7-form textarea, .wpcf7-form input[type=email], .wpcf7-form input[type=tel]');

        inputs.on('change keyup keydown keypress', function () {
            if ($.trim(this.value).length > 0) {
                var input = $(this);

                input.closest('.input-wrap').addClass('has-value');
            } else {
                $(this).closest('.input-wrap').removeClass('has-value');
            }
        });

        inputs.on('focusin', inputs, function () {
            $(this).closest('.input-wrap').addClass('focus');
            $(this).removeClass('wpcf7-not-valid');
            $(this).closest('.input-wrap').removeClass('error');
        });

        inputs.on('focusout', inputs, function () {
            $(this).closest('.input-wrap').removeClass('focus');
        });

        $('.form-box input[type=checkbox]').change(function () {
            $(this).removeClass('wpcf7-not-valid');
            $(this).closest('.input-wrap').removeClass('error');
        })
    }

    var onSentBad = function () {
            var eventID = event.detail.contactFormId;

            var inputs = $('[id^=wpcf7-f' + eventID + ']').find('input, textarea');

            var errors = $('[id^=wpcf7-f' + eventID + ']').find('.wpcf7-not-valid');

            errors.each(function () {
                $(this).closest('.input-wrap').addClass('error');
            })
        },
        onSentOk = function (event) {
            var eventID = event.detail.contactFormId;

            var submit = $('[id^=wpcf7-f' + eventID + ']').find('.wpcf7-form');

            submit.closest('.form-wrap').addClass('sent');
        },
        onSentInvalid = function () {

        },
        onSubmit = function () {
        };

    $(document).on('wpcf7submit', onSubmit);
    $(document).on('wpcf7mailsent', onSentOk);
    $(document).on('wpcf7invalid ', onSentBad);
    $(document).on('wpcf7mailfailed ', onSentInvalid);

    $(window).on('load', function () {
        inputHandler();
        $('.submit-form').on('click', function () {
            $('.wpcf7-form .button').click();
        });
    })

})(jQuery);